"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TdDetailsPropertyComponent = /** @class */ (function () {
    function TdDetailsPropertyComponent() {
    }
    return TdDetailsPropertyComponent;
}());
exports.TdDetailsPropertyComponent = TdDetailsPropertyComponent;
